import { portalRequest } from "./api";

const qs = (params = {}) => {
  const clean = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "");
  return clean.length ? "?" + new URLSearchParams(Object.fromEntries(clean)).toString() : "";
};

export const AuthService = {
  requestOtp: (email) => portalRequest("POST", "/request-otp", { email }),
  verifyOtp: (email, otp) => portalRequest("POST", "/verify-otp", { email, otp }),
  resendOtp: (email) => portalRequest("POST", "/resend-otp", { email }),
  logout: () => portalRequest("POST", "/logout"),
};

export const CorpClaimPortalService = {
  referenceData: (type) => portalRequest("GET", `/reference-data?type=${type}`),
  memberLookup: (params) => portalRequest("GET", `/member-lookup${qs(params)}`),

  list: (params = {}) => portalRequest("GET", `/claims${qs(params)}`),
  get: (id) => portalRequest("GET", `/claims/${id}`),
  submit: (data) => portalRequest("POST", "/claims", data),
  bulkSubmit: (data) => portalRequest("POST", "/claims/bulk", data),
  // Only accepted server-side while the claim is still SUBMITTED.
  update: (id, data) => portalRequest("PUT", `/claims/${id}`, data),
  remove: (id) => portalRequest("DELETE", `/claims/${id}`),
  uploadDocument: (claimId, formData) => portalRequest("POST", `/claims/${claimId}/documents`, formData),

  stats: () => portalRequest("GET", "/stats"),
  export: (params = {}) => portalRequest("GET", `/claims/export${qs(params)}`, undefined, "blob"),
};

export const CORP_CLAIM_STATUS = {
  DRAFT: { label: "Draft", color: "default" },
  PENDING_CRM_REVIEW: { label: "Awaiting Review", color: "magenta" },
  SUBMITTED: { label: "Submitted", color: "blue" },
  UNDER_REVIEW: { label: "Under Review", color: "gold" },
  MISSING_DOCUMENTS: { label: "Missing Documents", color: "orange" },
  RECOMMENDED_FOR_APPROVAL: { label: "Awaiting Review", color: "purple" },
  PENDING_FINAL_APPROVAL: { label: "Awaiting Final Approval", color: "geekblue" },
  APPROVED: { label: "Approved", color: "green" },
  REJECTED: { label: "Rejected", color: "red" },
  PAYMENT_PENDING: { label: "Payment Pending", color: "cyan" },
  PAID: { label: "Paid", color: "success" },
  CLOSED: { label: "Closed", color: "default" },
};

export default CorpClaimPortalService;
